/* import __COLOCATED_TEMPLATE__ from './seller-profile-notes.hbs'; */
import { computed } from '@ember/object';
import { readOnly } from '@ember/object/computed';
import { inject as service } from '@ember/service';
import Component from '@ember/component';
import { handleErrorResponseWithModal } from 'sh-www/utils/handles-errors';

const NOTE_MAX_LENGTH = 255;

export default Component.extend({
  NOTE_MAX_LENGTH,
  /**
   * HTML Component properties
   */
  tagName: 'section',
  classNames: ['SH-c-seller-profile-notes'],
  classNameBindings: ['_isShowNotes::hide'],

  session: service(),

  /** @param {User} user */
  currentUser: readOnly('session.currentUser'),

  /** @param {User} user */
  user: null,

  /** @param {Boolean} areNotesLoading */
  areNotesLoading: false,

  /** @param {Boolean} isAddingNewNote */
  isAddingNewNote: false,

  /** @param {Boolean} isSavingNewNote */
  isSavingNewNote: false,

  /** @param {Ember.A} profileNotesSorted */
  profileNotesSorted: null,

  /** @param {Function} toggleAddNewNote */
  toggleAddNewNote: () => {},

  /** @param {Function} saveNewNote */
  saveNewNote: () => {},

  /** @param {Ember.Object} isSavingEditedNoteMap */
  isSavingEditedNoteMap: null,

  /** @param {Ember.Object} isEditingNoteMap */
  isEditingNoteMap: null,

  /** @param {Function} toggleEditExistingNote */
  toggleEditExistingNote: () => {},

  /** @param {Function} updateNote */
  updateNote: () => {},

  /** @param {Function} deleteNote */
  deleteNote: () => {},

  /**
   * @type {Boolean}    True when notes are loading.
   */
  _areNotesLoading: readOnly('areNotesLoading'),

  /**
   * @type {Boolean}    True when adding a new note.
   */
  _isAddingNewNote: readOnly('isAddingNewNote'),

  /**
   * @type {Boolean}    True when saving a new note.
   */
  _isSavingNewNote: readOnly('isSavingNewNote'),

  /** @type {Boolean} Whether to show the notes. */
  _isShowNotes: computed('user.{isAdmin,isSeller}', function () {
    return !this.get('user.isAdmin') && this.get('user.isSeller');
  }),

  /**
   * @type {Ember.MutableArray<Note>}   The company notes for this profile sorted correctly
   */
  _profileNotes: readOnly('profileNotesSorted'),

  /**
   * @type {String}     The new note value to be added by the user.
   */
  _newNoteValue: '',

  actions: {
    /**
     * Called when the user clicks to add a note.
     *
     * @param {MouseEvent} e
     */
    onAddANoteClicked: function(e) {
      e.stopPropagation();
      e.preventDefault();

      this.get('toggleAddNewNote')(true);
    },

    /**
     * Called when user clicks the cancel action
     */
    onCancelAddNewNoteClicked: function() {
      this.get('toggleAddNewNote')(false);
    },

    /**
     * Called when user clicks the save action
     */
    onSaveAddNewNoteClicked: function() {
      return this.get('saveNewNote')(this.get('_newNoteValue')).then(() => {
        this.set('_newNoteValue', '');
      }).catch((e) => {
        handleErrorResponseWithModal(this, e);
      });
    },
  }
});
